import type { z } from "zod";

import type { checkoutConfigurationSchema } from "@commerce/shared/schemas/checkoutConfigurationSchema";

export type CheckoutV2DeliveryMethodType = "atHome" | "in-store delivery" | "custom delivery";

export type CheckoutV2ConfigurationBuilder = z.infer<typeof checkoutConfigurationSchema>;

export type AnyShippingMethod = NonNullable<CheckoutV2ConfigurationBuilder["shippingMethods"]>[number];

export type AtHomeDeliveryShippingMethod = Extract<AnyShippingMethod, { type: "atHome" }>;

export type InStoreDeliveryShippingMethod = Extract<AnyShippingMethod, { type: "in-store delivery" }>;

export type CustomDeliveryShippingMethod = Extract<AnyShippingMethod, { type: "custom delivery" }>;

export type CheckoutV2Configuration = Omit<CheckoutV2ConfigurationBuilder, "shippingMethods"> & {
  shippingMethods: AnyShippingMethod[];
};
